/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

export class ApplicationError {
	constructor(
		public message: string,
		public className: string,
		public methodName: string,
		public shouldOpenErrorDialog: boolean = true
	) {}
}
